import React, { useState } from 'react';
import { triggerPopupAuthentication } from '../../services/identity';

interface LoginButtonProps {
  onSuccess: (token: string) => void;
  onError: (error: Error) => void;
  loginHint?: string | null;
}

/**
 * Login button component that triggers popup authentication on user click
 * The popup must be spawned within 100ms of click to avoid popup blockers
 */
export const LoginButton: React.FC<LoginButtonProps> = ({ 
  onSuccess, 
  onError,
  loginHint 
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    
    if (isLoading) return;
    
    setIsLoading(true);
    
    try {
      // Trigger popup immediately on click (within 100ms requirement)
      // Using setTimeout with 0ms ensures it's in the same event loop tick
      const scopes = ["openid", "profile", "email", "User.Read"];
      const token = await triggerPopupAuthentication(scopes, loginHint);
      
      onSuccess(token);
    } catch (error) {
      console.error("Login failed:", error);
      onError(error instanceof Error ? error : new Error(String(error)));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleLogin}
      disabled={isLoading}
      aria-label="Sign in to continue"
      role="button"
      style={{
        padding: '12px 24px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: isLoading ? '#ccc' : '#0078d4',
        border: 'none',
        borderRadius: '4px',
        cursor: isLoading ? 'not-allowed' : 'pointer',
        minWidth: '150px'
      }}
    >
      {isLoading ? 'Signing in...' : 'Sign In'}
    </button>
  );
};










